import React, { useState, useEffect } from "react";
import { Image, Nav, NavDropdown, Offcanvas } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Images } from "../../../assets";
import { Link } from "react-router-dom";
import { fetchCategories } from "../../../redux/laws/action";
import { useTranslation } from "react-i18next";

const Sidebar = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const law = useSelector((state) => state.law);
  const { lawTypes } = law;
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleNavClick = (event) => {
    const target = event.target;
    // Close sidebar only if it's a direct navigation link
    if (target.tagName === "A" && !target.closest(".dropdown-toggle")) {
      handleClose();
    }
  };
  useEffect(() => {
    dispatch(fetchCategories(1, 10, "Lawlibrary"));
  }, []);
  return (
    <>
      <div
        className="toggle-icon flex-shrink-0"
        role="button"
        onClick={handleShow}
      >
        <Image src={Images.toggleIcon} alt="toggle-icon" loading="lazy" fluid />
      </div>
      <Offcanvas show={show} onHide={handleClose} placement="end">
        <Offcanvas.Header
          closeButton
          className="p-lg-4 p-3 justify-content-end"
        >
          {/* <Offcanvas.Title className='text-blue-1' id="offcanvasNavbarLabel-expand-false">
                                    </Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body className="pt-0 px-sm-4">
          <Nav
            className="ms-auto mb-4 sidebar-main-menu"
            onClick={handleNavClick}
          >
            <Nav.Link as={Link} to="/home">
              {t("nav.home")}
            </Nav.Link>
            <NavDropdown title={t("nav.aboutUs")}>
              <NavDropdown.Item as={Link} to="/about-us">
                {t("nav.aboutUs")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/chairman-message">
                {t("nav.chairmanMessage")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/general-secretary-message">
                {t("nav.generalSecretaryMessage")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/committee-members">
                {t("nav.committeeMembers")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/work-teams">
                {t("nav.workTeam")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/partners">
                {t("nav.partners")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/arbitration-uae">
                {t("nav.arbitrationInUAE")}
              </NavDropdown.Item>
              {/* <NavDropdown.Item as={Link} to="/jury-panel">
                                Jury Panel
                              </NavDropdown.Item> */}
              {/* <NavDropdown.Item as={Link} to="/law-library">
                                The Laws
                              </NavDropdown.Item> */}
            </NavDropdown>
            <NavDropdown title={t("nav.ourServices")}>
              <NavDropdown.Item as={Link} to="/arbitration">
                {t("nav.arbitration")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/mediation">
                {t("nav.mediation")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/technical">
                {t("nav.technicalPage")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/arbitration-mediation-logistics">
                {t("nav.logisticPage")}
              </NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title={t("nav.adrServices")}>
              {/* <NavDropdown.Item as={Link} to="/services">
                Services
              </NavDropdown.Item> */}
              <NavDropdown.Item as={Link} to="/arbitration">
                {t("nav.arbitration")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/mediation">
                {t("nav.mediation")}
              </NavDropdown.Item>
              <NavDropdown
                title={t("nav.technicalAndLogistic")}
                className="sub-dropdown"
              >
                <NavDropdown.Item as={Link} to="/technical">
                  {t("nav.technicalAndLogistic")}
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/arbitration-mediation-logistics"
                >
                  {t("nav.arbitrationAndMediationLogisticsServices")}
                </NavDropdown.Item>
              </NavDropdown>
            </NavDropdown>
            <NavDropdown title={t("nav.arbitrators")}>
              <NavDropdown.Item as={Link} to="#">
                {t("nav.applyArbitrator")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="#">
                {t("nav.applyExpert")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/code-of-conduct">
                {t("nav.codeOfConducts")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/member-of-arbitrators">
                {t("nav.ourMemberArbitratorsExperts")}
              </NavDropdown.Item>
              {/* <NavDropdown.Item as={Link} to="/fee-calculator">
                E-Calculator fees
              </NavDropdown.Item> */}
              {/* <NavDropdown.Item as={Link} to="/departments-Of-Center">
                                Departments Of The Center
                              </NavDropdown.Item>
                              <NavDropdown.Item as={Link} to="/center-tables">
                                Center Tables
                              </NavDropdown.Item> */}
            </NavDropdown>
            {/* <Nav.Link as={Link} to="/media-center">
                              Media Center
                            </Nav.Link> */}
            <NavDropdown title={t("nav.mediaCenter")}>
              <NavDropdown.Item as={Link} to="/legal-article">
                {t("nav.legalArticles")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/news">
                {t("nav.news")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/photos">
                {t("nav.gallery")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/videos">
                {t("nav.videos")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/events">
                {t("nav.events")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/workshops">
                {t("nav.workshops")}
              </NavDropdown.Item>
              <NavDropdown title={t("nav.course")} className="sub-dropdown">
                <NavDropdown.Item as={Link} to="/conference">
                  {t("nav.conference")}
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/arbitration-training-program">
                  {t("nav.arbitrationTrainingProgram")}
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/seminar">
                  {t("nav.seminar")}
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/diploma-course-of-international-arbitration"
                >
                  {t("nav.arbitrationProgramAndDiploma")}
                </NavDropdown.Item>
              </NavDropdown>
              {/* <NavDropdown.Item as={Link} to="/courses">
                                Training Courses
                              </NavDropdown.Item>
                              <NavDropdown.Item as={Link} to="/seminars">
                                Seminars & Conferences
                              </NavDropdown.Item>
                              <NavDropdown.Item as={Link} to="/libraries">
                                Electornic Library
                              </NavDropdown.Item> */}
            </NavDropdown>
            <NavDropdown title={t("nav.lawLibrary")}>
              <NavDropdown.Item as={Link} to="/law-library">
                {t("nav.lawLibrary")}
              </NavDropdown.Item>
              {lawTypes &&
                lawTypes?.categoriesList
                  ?.filter((item) =>
                    ["Arbitration", "Mediation", "Conventions"].includes(
                      item?.title,
                    ),
                  )
                  .map((item, index) => {
                    const linkTo =
                      item?.title === "Arbitration"
                        ? `/law/album/${item?.id}`
                        : `/law/${item?.id}`;

                    return (
                      <NavDropdown.Item as={Link} to={linkTo} key={index}>
                        {item?.title}
                      </NavDropdown.Item>
                    );
                  })}
            </NavDropdown>

            <Nav.Link as={Link} to="/contact-us">
              {t("nav.contactUs")}
            </Nav.Link>
          </Nav>
          <h4 className="text-blue-2 mb-3">{t("sidebar.usefulLink")}</h4>
          <Nav
            className="justify-content-end flex-grow-1"
            onClick={handleNavClick}
          >
            <Nav.Link as={Link} to="/Faqs">
              {t("sidebar.frequentlyAskedQuestions")}
            </Nav.Link>
            <Nav.Link as={Link} to="#">
              {t("sidebar.advertisementAreas")}
            </Nav.Link>
            <Nav.Link as={Link} to="#">
              {t("sidebar.termsAndConditions")}
            </Nav.Link>
            <Nav.Link as={Link} to="#">
              {t("sidebar.privacyPolicy")}
            </Nav.Link>
            <Nav.Link as={Link} to="#">
              {t("sidebar.usagePolicy")}
            </Nav.Link>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Sidebar;
